import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { usePageMeta } from "@/lib/seo";
import { LEGAL, LEGAL_LINKS, STAND } from "@/lib/legalTexts";

const Section = ({ s }) => (
  <section className="space-y-2">
    <h2 className="font-display text-base md:text-lg font-extrabold text-slate-900">{s.h}</h2>
    {s.p?.map((t, i) => <p key={i} className="text-sm sm:text-base text-slate-600 leading-relaxed">{t}</p>)}
    {s.list && <ul className="list-disc pl-5 space-y-1.5 text-sm sm:text-base text-slate-600 leading-relaxed marker:text-rose-400">{s.list.map((t) => <li key={t}>{t}</li>)}</ul>}
    {s.after?.map((t, i) => <p key={i} className="text-sm sm:text-base text-slate-600 leading-relaxed">{t}</p>)}
  </section>
);

export const LegalLinks = ({ className = "" }) => (
  <nav className={`flex flex-wrap gap-x-4 gap-y-1 ${className}`} data-testid="legal-links">
    {LEGAL_LINKS.map(([to, l]) => <Link key={to} to={to} data-testid={`legal-link-${to.slice(1)}`} className="hover:text-rose-600 transition-colors">{l}</Link>)}
  </nav>
);

export default function LegalPage({ page }) {
  const d = LEGAL[page];
  const { user } = useAuth();
  usePageMeta({ title: `${d.title} – itzPlay`, description: `${d.title} der itzPlay Community.` });
  return (
    <div className="min-h-screen noise-bg" data-testid={`legal-page-${page}`}>
      <header className="max-w-3xl mx-auto px-5 sm:px-8 pt-6 flex items-center justify-between">
        <Logo to={user ? "/feed" : "/"} />
        <Link to={user ? "/feed" : "/"} data-testid="legal-back" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-rose-600"><ArrowLeft className="w-4 h-4" /> Zurück</Link>
      </header>
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-10">
        <article className="bg-white rounded-3xl border border-pink-100 p-6 sm:p-10 space-y-7 shadow-sm">
          <div className="space-y-2">
            <p className="text-xs tracking-wider uppercase font-semibold text-rose-600">Rechtliches</p>
            <h1 className="font-display text-3xl sm:text-5xl font-extrabold tracking-tight break-words hyphens-auto" lang="de" data-testid="legal-title">{d.title}</h1>
            {d.intro && <p className="text-slate-500">{d.intro}</p>}
          </div>
          {d.sections.map((s) => <Section key={s.h} s={s} />)}
          <p className="text-xs text-slate-400 pt-4 border-t border-pink-50">Stand: {STAND}</p>
        </article>
        <LegalLinks className="justify-center mt-8 text-sm font-semibold text-slate-500" />
      </main>
    </div>
  );
}
